export default "__VITE_ASSET__CYOtlHoZ__"